import * as z from 'zod';
import { tFilterSchema } from '@modules/applications/tools-filter/filter-dialog/filter-schema';
export const tFiltersSchema = z
    .array(tFilterSchema)
    .min(1, { message: 'Please add at least one filter option' });
export const tFiltersFormSchema = z.object({ filters: tFiltersSchema });
